import React from 'react';
import { buildOnboardingMailtoLink } from '../api/register';

interface OnboardingErrorAlertProps {
  message: string;
  contactEmail: string;
  teamName: string;
}

const OnboardingErrorAlert: React.FC<OnboardingErrorAlertProps> = ({
  message,
  contactEmail,
  teamName,
}) => (
  <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
    <p>{message}</p>
    <div className="mt-3">
      <a
        href={buildOnboardingMailtoLink(contactEmail, teamName)}
        className="inline-flex items-center px-3 py-1.5 bg-red-700 text-white text-sm font-medium rounded hover:bg-red-800"
      >
        Contact admin
      </a>
    </div>
  </div>
);

export default OnboardingErrorAlert;
